import { DropdownMenu, DropdownMenuTrigger, DropdownMenuItem, DropdownMenuContent } from '@/components/ui/dropdown-menu';
import { IconButton } from '@/components/ui/button';
import { useNavigate, useParams } from 'react-router-dom';
import { usePatientDetailStore } from '@patientMenu/hooks/usePatientDetailStore';
import { scanWorkflows } from '@patientMenu/patientDetail/scanWorkflows';

export function PatientToolBar() {
  const { selectedScan } = usePatientDetailStore();
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();

  const workflows = scanWorkflows(patientId, selectedScan);

  const handleNavigate = (path: string | undefined, disabled: boolean) => {
    if (!disabled && path) {
      navigate(path);
    }
  };

  const actionBtnClass = 'rounded-lg px-3 text-xs font-medium';

  return (
    <div className="relative z-20 flex flex-wrap justify-end gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton variant="ghost-light" size="sm" className={actionBtnClass}>
            Workflows
          </IconButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-44" align="end">
          {workflows.map((workflow) => (
            <DropdownMenuItem
              key={workflow.key}
              className="rounded-lg"
              variant={workflow.disabled ? 'disabled' : 'default'}
              onClick={() => handleNavigate(workflow.path, workflow.disabled)}
            >
              {workflow.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton variant="ghost-light" size="sm" className={actionBtnClass}>
            Edit
          </IconButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-44" align="end">
          <DropdownMenuItem className="rounded-lg">Patient info</DropdownMenuItem>
          <DropdownMenuItem className="rounded-lg">Delete</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <IconButton
        variant="default"
        size="sm"
        className={actionBtnClass}
        onClick={() => navigate(`/import-scan/${patientId}`)}
      >
        Import
      </IconButton>
    </div>
  );
}
